var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopNoimage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "88px",
    viewBox: "0 0 124 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_img/store_noimage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 23 23.1428571 23 23.1428571 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1_img/store_noimage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A69762",
    x: 0,
    y: 0,
    width: 124,
    height: 88
  }), /*#__PURE__*/React.createElement("g", {
    id: "1_ico/nearshop",
    transform: "translate(49.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1.928571, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2142857,8 L21.2142857,8 C20.1497143,8 19.2857143,7.104 19.2857143,6 L19.2857143,0.32 C19.2857143,0.143 19.4236071,0 19.5942857,0 L22.8342857,0 C23.0049643,0 23.1428571,0.143 23.1428571,0.32 L23.1428571,6 C23.1428571,7.104 22.2788571,8 21.2142857,8",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3928571,8 L16.3928571,8 C15.3282857,8 14.4642857,7.104 14.4642857,6 L14.4642857,0.32 C14.4642857,0.143 14.6021786,0 14.7728571,0 L18.0128571,0 C18.1835357,0 18.3214286,0.143 18.3214286,0.32 L18.3214286,6 C18.3214286,7.104 17.4574286,8 16.3928571,8",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5714286,8 L11.5714286,8 C10.5068571,8 9.64285714,7.104 9.64285714,6 L9.64285714,0.32 C9.64285714,0.143 9.78075,0 9.95142857,0 L13.1914286,0 C13.3621071,0 13.5,0.143 13.5,0.32 L13.5,6 C13.5,7.104 12.636,8 11.5714286,8",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75,8 L6.75,8 C5.68542857,8 4.82142857,7.104 4.82142857,6 L4.82142857,0.32 C4.82142857,0.143 4.95932143,0 5.13,0 L8.37,0 C8.54067857,0 8.67857143,0.143 8.67857143,0.32 L8.67857143,6 C8.67857143,7.104 7.81457143,8 6.75,8",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92857143,8 L1.92857143,8 C0.864,8 0,7.104 0,6 L0,0.32 C0,0.143 0.137892857,0 0.308571429,0 L3.54857143,0 C3.71925,0 3.85714286,0.143 3.85714286,0.32 L3.85714286,6 C3.85714286,7.104 2.99314286,8 1.92857143,8",
    id: "Fill-9",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3928571,16 L20.25,16 L20.25,11 L16.3928571,11 L16.3928571,16 Z M9.64285714,16 L13.5,16 L13.5,11 L9.64285714,11 L9.64285714,16 Z M2.89285714,16 L6.75,16 L6.75,11 L2.89285714,11 L2.89285714,16 Z M0,9 L0,23 L7.71428571,23 L7.71428571,18 L15.4285714,18 L15.4285714,23 L23.1428571,23 L23.1428571,9 L0,9 Z",
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopNoimage);
export default __webpack_public_path__ + "static/media/shop_noimage.2b4254d0bc06bd94f46e1eb02594ad08.svg";
export { ForwardRef as ReactComponent };